import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Field = styled.label`display:flex; flex-direction:column; gap:6px; margin-bottom:10px; font-size:.85rem; font-weight:600; select,input { width:100%; box-sizing:border-box; padding:9px; border:1px solid var(--border-subtle); border-radius:4px; background:#fff; color:var(--ve-ink-800); font:inherit; font-weight:400; }`;

// The published table describes supported input fields, not an employer's tax
// configuration. Keep the technical code out of option labels and never infer
// taxable/net behavior merely from a supported name.
export const acceptsPayType = (entry, valueKind, deduction) => Boolean(
  (valueKind === 'days' ? entry.units : valueKind === 'hours' ? entry.units && entry.amount : entry.amount)
  && (!deduction || entry.negative)
);

export default function DanlonPayTypeSelect({ catalog, value, label, item, valueKind, deduction, disabled, onChange }) {
  const { t } = useTranslation();
  const tr = (key, options) => t(`admin.integrations.payrollSetup.${key}`, options);
  const supported = [...catalog.entries, ...catalog.families];
  const options = supported.filter((entry) => acceptsPayType(entry, valueKind, deduction)
    && (!item || entry.eligibleItems?.includes(item)));
  // Older reviewed employer mappings remain visible and unchanged until the
  // operator selects a replacement, even if new selections are more restricted.
  const legacySelection = value.payTypeId && !options.some((entry) => entry.id === value.payTypeId)
    ? supported.find((entry) => entry.id === value.payTypeId) || { id: value.payTypeId, label: value.payslipLabel || tr('existingSelection') }
    : null;
  const groups = [...new Set(options.map((entry) => entry.group))];
  const family = catalog.families.find((entry) => entry.id === value.payTypeId);
  return <>
    <Field>{label}
      <select aria-label={label} disabled={disabled} value={value.payTypeId || ''} onChange={(event) => {
        const next = supported.find((entry) => entry.id === event.target.value);
        onChange({ payTypeId: event.target.value, customNumber: next?.minimum,
          amountMultiplier: next?.defaultAmountMultiplier ?? 1, payslipLabel: '' });
      }}>
        <option value="">{tr('unmapped')}</option>
        {legacySelection && <option value={legacySelection.id}>{legacySelection.label} ({tr('existingSelection')})</option>}
        {groups.map((group) => <optgroup label={group} key={group}>
          {options.filter((entry) => entry.group === group).map((entry) => <option value={entry.id} key={entry.id}>{entry.label}</option>)}
        </optgroup>)}
      </select>
    </Field>
    {family && <Field>{tr('customNumber')}
      <input aria-label={`${label} — ${tr('customNumber')}`} type="number" required disabled={disabled}
        min={family.minimum} max={Number.MAX_SAFE_INTEGER} step="1" value={value.customNumber ?? family.minimum}
        onChange={(event) => onChange({ customNumber: event.target.value === '' ? '' : Number(event.target.value), payslipLabel: '' })} />
    </Field>}
  </>;
}
